// 登录登出
import $ from '../base'

export default {

  // 登录
  login: $.post('crm/login/into'),

  // 验证码
  captcha: $.post('crm/login/captcha'),

  // 用户状态
  status: $.post('crm/login/status'),

  // 登出
  logout: $.post('crm/login/exit')

}
